import { Component, Input, OnInit } from '@angular/core';
import { MatDialogClose } from '@angular/material/dialog';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  standalone: true,
  imports: [NgIf, MatDialogClose]
})
export class ModalComponent implements OnInit {
  @Input() subtitle: string;
  @Input() title: string;

  ngOnInit() {}
}
